import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.status.error.title',
        defaultMessage: 'Card issuance failed',
    },
    subtitle: {
        id: 'modal.status.error.subtitle',
        defaultMessage: 'Please try again or contact support for assistance.',
    },
    contact: {
        id: 'modal.status.error.contact',
        defaultMessage: 'Contact support',
    },
    button: {
        id: 'modal.status.error.close',
        defaultMessage: 'Close',
    },
})
